module.exports = __webpack_public_path__ + "static/media/axe-common.7d5db7c5.png";